import React from "react";
import "@awsui/global-styles/index.css"
import Grid from 'aws-northstar/layouts/Grid'

const Logout = () => {
  console.log("Dashboard");

  return (
    <>
      <Grid 
        container
        spacing={0}
        align="center"
        justify="center"
        direction="column"
      >
        <Grid item>
            <h2>You have successfully logged out, you may now close your browser.</h2>
        </Grid>
      </Grid>  
    </>
  );
};

export default Logout;
